export default "__VITE_ASSET__iEVwor8o__"